/*
 * @Descripttion: 
 * @Author: qhx
 * @Date: 2025-02-12 15:06:08
 * @LastEditTime: 2025-02-12 16:42:52
 */
import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction} from '@reduxjs/toolkit';

import { getLanguage } from '@/utils/utils';
export type Language = 'zh' | 'en';
interface ICommomType {
  language: Language,
}

const initialState:ICommomType = {
  language: getLanguage(),
};
export const common = createSlice({
  name: 'common',
  initialState,
  reducers: {
    setLanguage: (state, {payload}: PayloadAction<ICommomType['language']> ) => {
      state.language = payload;
    },
  }
});

export const { setLanguage } = common.actions;
export default common.reducer;